var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgService5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 3710 3710",
    style: {
      enableBackground: "new 0 0 3710 3710"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Background"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#FFFFFF"
    },
    width: 3710,
    height: 3710
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Illustration"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 3599.4587,
    y1: 4056.6587,
    x2: 1129.0614,
    y2: 988.58
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    d: "M2919.837,2846.719c-56.744,59.738-110.435,98.262-152.855,128.699 c-498.638,357.779-1088.66,253.488-1214.056,228.019c-185.171-37.609-543.102-110.307-801.88-414.625 C359.536,2328.406,420.5,1603.047,724.181,1124.228c55.548-87.584,348.969-573.697,945.345-651.654 c360.921-47.179,781.638,47.975,1086.31,303.23C3395.371,1311.607,3349.843,2394.023,2919.837,2846.719z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M503.991,1383.122c-1.365,0-2.649-0.841-3.147-2.199c-1.549-4.219-3.042-8.459-4.486-12.726 c-0.593-1.753,0.347-3.656,2.102-4.25c1.765-0.594,3.657,0.347,4.25,2.102c1.424,4.211,2.898,8.397,4.427,12.562 c0.638,1.739-0.252,3.666-1.991,4.302C504.767,1383.054,504.374,1383.122,503.991,1383.122z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M487.58,1329.788c-1.503,0-2.868-1.015-3.248-2.539c-2.125-8.484-4.057-17.11-5.746-25.638 c-0.357-1.817,0.822-3.58,2.639-3.941c1.811-0.372,3.579,0.82,3.942,2.637c1.663,8.42,3.572,16.936,5.668,25.314 c0.452,1.796-0.642,3.617-2.436,4.067C488.124,1329.755,487.849,1329.788,487.58,1329.788z M475.308,1262.405 c-1.68,0-3.13-1.259-3.327-2.968c-0.999-8.639-1.801-17.442-2.38-26.163c-0.121-1.848,1.277-3.446,3.124-3.569 c1.817-0.1,3.448,1.277,3.569,3.124c0.57,8.613,1.362,17.306,2.348,25.839c0.213,1.839-1.107,3.504-2.944,3.715 C475.567,1262.398,475.436,1262.405,475.308,1262.405z M471.824,1194c-0.013,0-0.029,0-0.029,0 c-1.866-0.025-3.346-1.544-3.323-3.395c0.111-8.718,0.439-17.547,0.972-26.244c0.111-1.848,1.677-3.256,3.553-3.142 c1.847,0.113,3.255,1.704,3.14,3.553c-0.527,8.589-0.851,17.31-0.959,25.918C475.154,1192.526,473.658,1194,471.824,1194z  M477.086,1125.734c-0.157,0-0.314-0.012-0.475-0.033c-1.834-0.262-3.107-1.96-2.849-3.793 c1.228-8.626,2.688-17.341,4.345-25.905c0.35-1.817,2.109-2.998,3.926-2.657c1.817,0.352,3.009,2.11,2.655,3.927 c-1.631,8.456-3.075,17.062-4.286,25.58C480.164,1124.525,478.73,1125.734,477.086,1125.734z M491.113,1058.715 c-0.298,0-0.602-0.041-0.904-0.124c-1.781-0.496-2.826-2.346-2.328-4.129c2.325-8.351,4.902-16.804,7.665-25.122 c0.583-1.758,2.479-2.709,4.24-2.127c1.755,0.584,2.708,2.482,2.125,4.239c-2.728,8.217-5.275,16.563-7.574,24.808 C493.926,1057.743,492.58,1058.715,491.113,1058.715z M513.752,994.054c-0.439,0-0.884-0.087-1.313-0.268 c-1.703-0.725-2.498-2.695-1.771-4.397c3.412-8.03,7.079-16.088,10.897-23.953c0.809-1.667,2.813-2.356,4.479-1.554 c1.667,0.809,2.361,2.816,1.552,4.481c-3.769,7.765-7.387,15.723-10.759,23.649 C516.296,993.288,515.055,994.054,513.752,994.054z M544.622,932.851c-0.58,0-1.166-0.149-1.699-0.463 c-1.595-0.941-2.125-2.996-1.185-4.592c4.42-7.503,9.096-15.014,13.896-22.321c1.018-1.544,3.104-1.971,4.643-0.961 c1.549,1.018,1.978,3.096,0.963,4.645c-4.741,7.215-9.358,14.631-13.726,22.043 C546.888,932.262,545.771,932.851,544.622,932.851z M583.138,876.181c-0.72,0-1.444-0.231-2.056-0.707 c-1.46-1.138-1.722-3.245-0.586-4.705c5.357-6.881,10.959-13.721,16.65-20.332c1.211-1.408,3.327-1.56,4.728-0.354 c1.405,1.208,1.562,3.325,0.354,4.728c-5.619,6.529-11.152,13.282-16.44,20.076 C585.125,875.737,584.136,876.181,583.138,876.181z M628.614,824.956c-0.864,0-1.726-0.332-2.384-0.994 c-1.303-1.316-1.29-3.438,0.023-4.741c6.202-6.139,12.632-12.2,19.115-18.017c1.375-1.233,3.497-1.125,4.735,0.259 c1.238,1.378,1.123,3.497-0.255,4.735c-6.404,5.742-12.753,11.727-18.873,17.788 C630.32,824.634,629.466,824.956,628.614,824.956z M680.273,780.011c-1.012,0-2.01-0.453-2.669-1.32 c-1.123-1.472-0.841-3.576,0.632-4.699c6.912-5.273,14.063-10.455,21.253-15.401c1.526-1.049,3.612-0.663,4.663,0.861 c1.048,1.526,0.661,3.613-0.864,4.663c-7.099,4.885-14.161,10.001-20.985,15.208 C681.697,779.787,680.98,780.011,680.273,780.011z M737.266,742.098c-1.159,0-2.289-0.602-2.911-1.68 c-0.923-1.606-0.37-3.656,1.234-4.579c7.567-4.355,15.324-8.567,23.051-12.521c1.64-0.848,3.664-0.193,4.512,1.457 c0.841,1.649,0.19,3.669-1.46,4.512c-7.629,3.903-15.284,8.063-22.756,12.364C738.408,741.954,737.832,742.098,737.266,742.098 z M1223.529,720.9c-0.472,0-0.953-0.102-1.411-0.314c-7.829-3.638-15.831-7.118-23.791-10.347 c-1.716-0.696-2.541-2.652-1.847-4.368c0.701-1.721,2.662-2.541,4.368-1.847c8.061,3.269,16.169,6.796,24.099,10.481 c1.677,0.779,2.407,2.773,1.627,4.453C1226.004,720.18,1224.793,720.9,1223.529,720.9z M798.642,711.886 c-1.316,0-2.564-0.781-3.097-2.073c-0.707-1.711,0.105-3.672,1.814-4.379c8.048-3.332,16.277-6.5,24.456-9.42 c1.739-0.62,3.661,0.288,4.283,2.03c0.625,1.745-0.285,3.664-2.03,4.286c-8.074,2.883-16.198,6.012-24.141,9.299 C799.507,711.803,799.071,711.886,798.642,711.886z M1159.66,696.14c-0.331,0-0.671-0.051-1.005-0.155 c-8.202-2.58-16.591-4.99-24.937-7.164c-1.791-0.467-2.868-2.299-2.4-4.09c0.468-1.794,2.318-2.867,4.09-2.4 c8.454,2.204,16.951,4.645,25.258,7.256c1.768,0.557,2.747,2.438,2.194,4.204C1162.407,695.223,1161.088,696.14,1159.66,696.14 z M863.418,689.893c-1.48,0-2.832-0.987-3.235-2.485c-0.481-1.788,0.583-3.626,2.371-4.106 c8.415-2.258,17.007-4.334,25.53-6.174c1.82-0.378,3.595,0.76,3.985,2.57c0.39,1.811-0.76,3.594-2.57,3.985 c-8.418,1.816-16.899,3.867-25.209,6.095C863.997,689.857,863.706,689.893,863.418,689.893z M1093.107,679.901 c-0.193,0-0.386-0.016-0.586-0.051c-8.474-1.493-17.108-2.793-25.657-3.864c-1.837-0.229-3.14-1.906-2.911-3.744 c0.229-1.834,1.902-3.138,3.742-2.909c8.661,1.085,17.406,2.402,25.992,3.913c1.824,0.321,3.042,2.06,2.718,3.883 C1096.119,678.757,1094.705,679.901,1093.107,679.901z M930.567,676.497c-1.657,0-3.097-1.226-3.32-2.912 c-0.246-1.835,1.048-3.52,2.881-3.764c8.628-1.146,17.413-2.092,26.109-2.813c1.886-0.164,3.464,1.221,3.621,3.065 c0.151,1.845-1.221,3.466-3.065,3.618c-8.589,0.712-17.262,1.645-25.782,2.777 C930.862,676.488,930.715,676.497,930.567,676.497z M1025.008,672.421c-0.052,0-0.102-0.002-0.154-0.003 c-7.442-0.336-15.003-0.516-22.468-0.539l-1.595-0.003l-1.896,0.003c0,0-0.007,0-0.01,0c-1.847,0-3.35-1.495-3.353-3.345 c-0.003-1.852,1.493-3.356,3.343-3.361l1.916-0.003l1.624,0.003c7.551,0.023,15.206,0.206,22.74,0.545 c1.85,0.083,3.281,1.65,3.199,3.5C1028.272,671.018,1026.789,672.421,1025.008,672.421z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M1273.164,747.27c-0.589,0-1.185-0.154-1.726-0.48c-3.801-2.287-7.632-4.527-11.496-6.72 c-1.611-0.914-2.177-2.96-1.264-4.571c0.913-1.606,2.963-2.177,4.571-1.261c3.916,2.22,7.799,4.489,11.647,6.806 c1.588,0.956,2.099,3.016,1.143,4.602C1275.41,746.692,1274.3,747.27,1273.164,747.27z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M1514.618,1074.329c-1.506,0-2.878-1.023-3.251-2.554c-1.061-4.317-2.174-8.616-3.343-12.893 c-0.488-1.788,0.567-3.631,2.351-4.119c1.765-0.475,3.628,0.563,4.119,2.351c1.182,4.332,2.308,8.687,3.382,13.063 c0.442,1.798-0.658,3.613-2.456,4.055C1515.151,1074.298,1514.883,1074.329,1514.618,1074.329z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M989.082,1729.831c-0.023,0-0.049,0-0.072,0c-9.08-0.198-18.267-0.632-27.308-1.288 c-1.847-0.134-3.235-1.74-3.101-3.589c0.134-1.845,1.768-3.224,3.585-3.101c8.929,0.65,18.002,1.077,26.967,1.274 c1.853,0.039,3.32,1.573,3.281,3.425C992.396,1728.377,990.903,1729.831,989.082,1729.831z M1033.2,1728.988 c-1.758,0-3.235-1.372-3.343-3.15c-0.111-1.85,1.297-3.438,3.143-3.549c8.942-0.54,17.983-1.318,26.872-2.312 c1.863-0.21,3.497,1.12,3.707,2.958c0.203,1.842-1.12,3.5-2.96,3.705c-9.001,1.007-18.159,1.794-27.213,2.341 C1033.338,1728.986,1033.269,1728.988,1033.2,1728.988z M918.112,1723.53c-0.174,0-0.347-0.013-0.524-0.041 c-8.968-1.408-18.015-3.066-26.885-4.933c-1.811-0.381-2.97-2.159-2.59-3.972c0.38-1.813,2.168-2.975,3.972-2.59 c8.755,1.842,17.688,3.481,26.545,4.87c1.827,0.286,3.078,2.002,2.793,3.833C921.16,1722.349,919.736,1723.53,918.112,1723.53z  M1103.824,1719.939c-1.568,0-2.97-1.107-3.287-2.703c-0.357-1.817,0.825-3.58,2.642-3.939 c8.782-1.734,17.635-3.72,26.315-5.904c1.798-0.444,3.621,0.635,4.07,2.433c0.452,1.796-0.639,3.618-2.433,4.07 c-8.795,2.212-17.76,4.224-26.656,5.979C1104.256,1719.92,1104.04,1719.939,1103.824,1719.939z M848.631,1707.743 c-0.318,0-0.642-0.046-0.963-0.142c-8.693-2.608-17.432-5.476-25.969-8.525c-1.745-0.624-2.656-2.542-2.03-4.286 c0.622-1.742,2.544-2.657,4.283-2.03c8.431,3.011,17.059,5.843,25.641,8.417c1.775,0.532,2.78,2.402,2.249,4.175 C851.408,1706.803,850.075,1707.743,848.631,1707.743z M1172.594,1701.453c-1.392,0-2.695-0.876-3.173-2.266 c-0.599-1.752,0.334-3.659,2.086-4.26c8.471-2.908,16.977-6.074,25.278-9.412c1.716-0.693,3.667,0.141,4.361,1.86 c0.691,1.717-0.141,3.671-1.86,4.361c-8.408,3.381-17.023,6.588-25.605,9.533 C1173.321,1701.394,1172.954,1701.453,1172.594,1701.453z M781.927,1682.699c-0.465,0-0.936-0.097-1.385-0.301 c-8.271-3.764-16.538-7.786-24.577-11.956c-1.644-0.853-2.282-2.876-1.431-4.52c0.851-1.647,2.872-2.287,4.522-1.432 c7.934,4.117,16.1,8.089,24.263,11.805c1.686,0.768,2.43,2.755,1.663,4.44C784.419,1681.971,783.201,1682.699,781.927,1682.699 z M1238.214,1673.836c-1.228,0-2.41-0.674-2.999-1.847c-0.832-1.654-0.164-3.669,1.49-4.502 c7.983-4.016,15.972-8.294,23.745-12.717c1.595-0.918,3.651-0.354,4.571,1.256c0.917,1.609,0.354,3.656-1.257,4.573 c-7.868,4.479-15.959,8.813-24.047,12.881C1239.236,1673.721,1238.718,1673.836,1238.214,1673.836z M1299.493,1637.648 c-1.071,0-2.119-0.509-2.77-1.459c-1.044-1.528-0.655-3.615,0.871-4.661c7.364-5.041,14.711-10.357,21.843-15.798 c1.47-1.126,3.575-0.838,4.699,0.63c1.123,1.473,0.841,3.577-0.632,4.7c-7.22,5.511-14.662,10.895-22.118,16.001 C1300.806,1637.458,1300.144,1637.648,1299.493,1637.648z M1355.392,1593.561c-0.914,0-1.827-0.373-2.489-1.105 c-1.241-1.374-1.133-3.494,0.242-4.736c6.64-6,13.215-12.254,19.544-18.587c1.31-1.313,3.432-1.31,4.741-0.003 c1.31,1.31,1.31,3.432,0,4.741c-6.405,6.414-13.065,12.749-19.793,18.826 C1356.999,1593.276,1356.194,1593.561,1355.392,1593.561z M1404.916,1542.385c-0.763,0-1.532-0.26-2.161-0.792 c-1.415-1.197-1.591-3.312-0.396-4.726c5.789-6.845,11.476-13.926,16.899-21.044c1.123-1.472,3.222-1.762,4.702-0.635 c1.47,1.121,1.755,3.227,0.635,4.699c-5.494,7.208-11.25,14.379-17.115,21.313 C1406.815,1541.981,1405.868,1542.385,1404.916,1542.385z M1447.174,1485.033c-0.616,0-1.241-0.17-1.801-0.526 c-1.559-0.995-2.017-3.07-1.022-4.63c4.823-7.564,9.509-15.347,13.932-23.133c0.91-1.609,2.953-2.176,4.571-1.261 c1.608,0.914,2.174,2.962,1.257,4.571c-4.476,7.886-9.224,15.769-14.109,23.428 C1449.364,1484.486,1448.28,1485.033,1447.174,1485.033z M1481.361,1422.503c-0.468,0-0.946-0.098-1.401-0.309 c-1.683-0.776-2.417-2.767-1.641-4.448c3.759-8.142,7.357-16.491,10.691-24.819c0.691-1.721,2.642-2.554,4.361-1.865 c1.719,0.689,2.554,2.641,1.866,4.36c-3.379,8.433-7.023,16.889-10.828,25.133 C1483.843,1421.781,1482.628,1422.503,1481.361,1422.503z M1506.799,1355.901c-0.324,0-0.655-0.049-0.982-0.149 c-1.768-0.542-2.767-2.416-2.223-4.186c2.61-8.534,5.039-17.277,7.22-25.987c0.449-1.799,2.272-2.893,4.067-2.439 c1.794,0.45,2.888,2.271,2.436,4.067c-2.207,8.821-4.666,17.676-7.312,26.32 C1509.562,1354.971,1508.236,1355.901,1506.799,1355.901z M1522.967,1286.551c-0.177,0-0.36-0.013-0.54-0.044 c-1.83-0.296-3.071-2.02-2.773-3.847c1.434-8.81,2.662-17.801,3.647-26.723c0.206-1.839,1.853-3.152,3.7-2.965 c1.843,0.205,3.169,1.861,2.966,3.702c-0.999,9.035-2.243,18.141-3.693,27.064 C1526.006,1285.382,1524.582,1286.551,1522.967,1286.551z M1529.663,1215.666c-0.033,0-0.066,0-0.095-0.002 c-1.853-0.051-3.31-1.593-3.261-3.445c0.121-4.35,0.187-8.713,0.2-13.089l0.003-1.583c0.003-4.116-0.046-8.219-0.141-12.31 c-0.042-1.852,1.424-3.386,3.274-3.428c1.824-0.172,3.389,1.423,3.431,3.274c0.095,4.144,0.144,8.299,0.141,12.467 l-0.003,1.611c-0.013,4.42-0.078,8.839-0.2,13.245C1532.96,1214.225,1531.471,1215.666,1529.663,1215.666z M1526.887,1144.489 c-1.693,0-3.147-1.277-3.33-2.998c-0.953-8.95-2.141-17.95-3.533-26.75c-0.291-1.829,0.956-3.546,2.786-3.836 c1.824-0.293,3.549,0.959,3.834,2.788c1.411,8.911,2.616,18.025,3.579,27.087c0.196,1.842-1.136,3.494-2.98,3.69 C1527.126,1144.482,1527.005,1144.489,1526.887,1144.489z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M719.001,1648.735c-0.612,0-1.228-0.167-1.784-0.516c-3.805-2.4-7.58-4.848-11.319-7.339 c-1.539-1.027-1.958-3.107-0.93-4.648c1.025-1.544,3.104-1.961,4.649-0.933c3.693,2.461,7.416,4.879,11.175,7.246 c1.565,0.989,2.037,3.058,1.048,4.625C721.205,1648.181,720.115,1648.735,719.001,1648.735z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M734.849,1504.872c1.847,1.981,4.749,2.572,7.224,1.472l70.614-31.406 c29.986,20.085,63.39,35.535,99.235,45.261l22.617,73.846c0.792,2.591,3.143,4.392,5.85,4.487l92.643,3.232 c2.708,0.094,5.177-1.54,6.148-4.067l27.707-72.092c36.437-7.206,70.835-20.288,102.147-38.236l68.254,36.249 c2.393,1.27,5.327,0.883,7.308-0.964l67.794-63.223c1.982-1.849,2.572-4.75,1.471-7.224l-31.405-70.613 c20.085-29.985,35.533-63.391,45.26-99.236l73.847-22.617c2.59-0.793,4.392-3.142,4.486-5.849l3.232-92.644 c0.094-2.708-1.539-5.177-4.069-6.148l-72.092-27.707c-7.205-36.437-20.287-70.835-38.235-102.147l36.25-68.255 c1.27-2.392,0.883-5.328-0.964-7.308l-63.224-67.793c-1.847-1.983-4.749-2.572-7.224-1.471l-70.613,31.406 c-29.984-20.087-63.39-35.535-99.235-45.261l-22.617-73.848c-0.793-2.59-3.142-4.391-5.849-4.487l-92.645-3.231 c-2.706-0.095-5.175,1.539-6.147,4.068l-27.707,72.091c-36.436,7.204-70.836,20.288-102.148,38.237l-68.253-36.249 c-2.392-1.272-5.329-0.883-7.309,0.964l-67.793,63.223c-1.98,1.847-2.572,4.748-1.471,7.224l31.405,70.613 c-20.086,29.985-35.534,63.391-45.26,99.236l-73.848,22.617c-2.589,0.792-4.392,3.142-4.485,5.85l-3.232,92.642 c-0.094,2.707,1.538,5.177,4.067,6.149l72.091,27.707c7.206,36.435,20.289,70.835,38.236,102.147l-36.248,68.254 c-1.271,2.392-0.884,5.326,0.964,7.309L734.849,1504.872z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000153692095618297929340000017797700063630818993_",
    gradientUnits: "userSpaceOnUse",
    x1: 913.5272,
    y1: 1193.3879,
    x2: 1088.2679,
    y2: 1193.3879
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000153692095618297929340000017797700063630818993_)"
    },
    d: "M1000.722,1280.751 c-16.607,0-32.887-4.761-47.176-13.98c-19.603-12.649-33.107-32.173-38.025-54.977c-4.921-22.806-0.665-46.161,11.984-65.764 c12.649-19.605,32.173-33.11,54.979-38.028c47.091-10.165,93.638,19.891,103.789,66.966 c4.921,22.806,0.665,46.161-11.984,65.764c-12.649,19.605-32.173,33.108-54.979,38.026l0,0 C1013.129,1280.091,1006.901,1280.751,1000.722,1280.751z M1000.912,1116.089c-5.383,0-10.838,0.567-16.306,1.745 c-20.18,4.352-37.458,16.301-48.646,33.648c-11.192,17.346-14.96,38.011-10.609,58.189 c4.355,20.179,16.303,37.456,33.65,48.648c17.347,11.195,38.021,14.96,58.188,10.605l0,0 c20.18-4.352,37.458-16.3,48.646-33.647c11.192-17.346,14.96-38.011,10.609-58.189 C1068.638,1140.902,1036.517,1116.089,1000.912,1116.089z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000038400044929438180600000017483827629172639402_",
    gradientUnits: "userSpaceOnUse",
    x1: 773.512,
    y1: 1191.9208,
    x2: 1230.9354,
    y2: 1191.9208
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000038400044929438180600000017483827629172639402_)"
    },
    d: "M1002.327,1420.634 c-2.688,0-5.37-0.046-8.078-0.141c-6.797-0.237-13.582-0.776-20.317-1.608c-0.206-0.026-0.409-0.051-0.612-0.077 c-0.016-0.002-0.03-0.003-0.03-0.003c-0.075-0.01-0.138-0.018-0.203-0.026c-0.111-0.013-0.223-0.028-0.334-0.043l-0.013-0.002 c-5.949-0.766-11.859-1.765-17.704-2.988c-0.046-0.01-0.085-0.018-0.131-0.028c-0.848-0.178-1.699-0.362-2.544-0.55 c-1.192-0.264-2.377-0.537-3.563-0.82c-0.92-0.221-1.84-0.447-2.76-0.678l2.462-9.754c14.987,3.783,30.5,5.979,46.102,6.524 c120.399,4.227,221.939-90.403,226.14-210.896c0.092-2.588,0.134-5.168,0.134-7.739 c-0.01-117.066-93.128-214.288-211.032-218.402c-120.583-4.221-221.935,90.408-226.14,210.896 c-0.088,2.554-0.134,5.105-0.134,7.654c0,36.99,9.338,73.356,27.187,105.629l-8.801,4.869 c-18.673-33.765-28.444-71.807-28.444-110.498c0-2.665,0.046-5.334,0.141-8.004c4.394-126.035,110.544-225.03,236.546-220.598 c123.323,4.302,220.727,105.997,220.737,228.45c0,2.688-0.046,5.386-0.141,8.094 C1226.492,1323.222,1124.779,1420.634,1002.327,1420.634z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M1397.899,923.199l38.045-20.677c17.64,9.887,36.983,17.032,57.435,20.873l15.912,40.24 c0.558,1.412,1.95,2.313,3.466,2.247l51.887-2.309c1.517-0.068,2.823-1.09,3.254-2.545l12.274-41.495 c20.031-5.643,38.662-14.477,55.354-25.892l39.731,17.215c1.393,0.603,3.015,0.256,4.039-0.863l35.057-38.322 c1.024-1.121,1.225-2.767,0.501-4.101l-20.676-38.044c9.887-17.64,17.032-36.984,20.872-57.436l40.242-15.911 c1.411-0.558,2.313-1.95,2.245-3.466l-2.309-51.887c-0.067-1.516-1.089-2.823-2.545-3.253l-41.495-12.274 c-5.642-20.031-14.477-38.663-25.892-55.354l17.216-39.732c0.603-1.392,0.257-3.014-0.863-4.039l-38.323-35.056 c-1.12-1.026-2.767-1.226-4.1-0.501l-38.045,20.676c-17.64-9.887-36.983-17.032-57.436-20.872l-15.911-40.242 c-0.558-1.411-1.95-2.313-3.466-2.246l-51.888,2.31c-1.516,0.067-2.823,1.089-3.253,2.545l-12.274,41.496 c-20.031,5.642-38.663,14.477-55.354,25.892l-39.73-17.215c-1.392-0.604-3.016-0.257-4.04,0.863l-35.056,38.323 c-1.024,1.12-1.225,2.766-0.501,4.1l20.676,38.045c-9.887,17.64-17.032,36.983-20.872,57.435l-40.242,15.912 c-1.411,0.557-2.313,1.95-2.245,3.466l2.309,51.887c0.068,1.517,1.089,2.823,2.545,3.254l41.495,12.274 c5.642,20.03,14.477,38.662,25.892,55.354l-17.215,39.731c-0.603,1.393-0.257,3.014,0.863,4.04l38.323,35.056 C1394.919,923.722,1396.566,923.924,1397.899,923.199z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000072242367796368460810000005272700409319434895_",
    gradientUnits: "userSpaceOnUse",
    x1: 1477.3899,
    y1: 736.907,
    x2: 1579.7329,
    y2: 736.907
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000072242367796368460810000005272700409319434895_)"
    },
    d: "M1528.494,788.079 c-8.346,0-16.611-2.065-24.168-6.131c-12.033-6.473-20.821-17.244-24.75-30.33c-3.929-13.084-2.531-26.917,3.942-38.946 c6.473-12.031,17.246-20.821,30.33-24.751c13.087-3.932,26.921-2.528,38.951,3.944c12.03,6.473,20.818,17.246,24.747,30.332 c3.929,13.082,2.531,26.915-3.942,38.946c-6.473,12.031-17.246,20.821-30.33,24.75 C1538.409,787.356,1533.435,788.079,1528.494,788.079z M1528.615,695.8c-3.972,0-7.963,0.581-11.873,1.755 c-10.51,3.158-19.165,10.219-24.364,19.883c-5.203,9.664-6.326,20.777-3.169,31.288c3.156,10.512,10.219,19.164,19.881,24.366 c9.666,5.203,20.782,6.326,31.289,3.17c10.51-3.156,19.165-10.219,24.364-19.883c5.203-9.666,6.326-20.777,3.169-31.288 c-3.156-10.512-10.216-19.166-19.882-24.366C1541.962,697.458,1535.321,695.8,1528.615,695.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M1306.235,907.917c-1.018,0-2.02-0.46-2.678-1.334c-2.708-3.585-5.367-7.295-7.904-11.025 c-1.044-1.531-0.648-3.617,0.884-4.659c1.529-1.041,3.615-0.645,4.656,0.884c2.482,3.643,5.075,7.262,7.714,10.763 c1.117,1.478,0.822,3.581-0.655,4.695C1307.646,907.698,1306.938,907.917,1306.235,907.917z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M1277.332,860.279c-1.254,0-2.456-0.704-3.029-1.911c-3.766-7.904-7.207-16.093-10.229-24.341 c-0.635-1.739,0.259-3.664,1.997-4.301c1.742-0.635,3.667,0.257,4.302,1.996c2.947,8.052,6.306,16.046,9.98,23.762 c0.799,1.672,0.088,3.674-1.585,4.469C1278.305,860.174,1277.814,860.279,1277.332,860.279z M1255.67,795.466 c-1.562,0-2.96-1.095-3.281-2.683c-1.758-8.629-3.124-17.408-4.054-26.091c-0.197-1.84,1.136-3.494,2.976-3.69 c1.856-0.192,3.497,1.136,3.69,2.976c0.91,8.474,2.24,17.043,3.955,25.466c0.37,1.814-0.799,3.585-2.616,3.955 C1256.115,795.445,1255.892,795.466,1255.67,795.466z M1250.378,727.321c-0.052,0-0.105-0.002-0.157-0.003 c-1.85-0.085-3.281-1.655-3.196-3.503c0.406-8.775,1.234-17.622,2.466-26.294c0.262-1.834,1.958-3.112,3.792-2.849 c1.834,0.26,3.107,1.958,2.849,3.792c-1.202,8.462-2.01,17.097-2.407,25.659C1253.643,725.92,1252.16,727.321,1250.378,727.321z  M1261.93,659.975c-0.321,0-0.645-0.047-0.969-0.144c-1.771-0.535-2.777-2.407-2.24-4.18c2.534-8.392,5.494-16.768,8.805-24.89 c0.694-1.717,2.655-2.542,4.368-1.842c1.716,0.699,2.541,2.655,1.84,4.37c-3.228,7.932-6.12,16.106-8.595,24.3 C1264.703,659.039,1263.371,659.975,1261.93,659.975z M1289.519,597.464c-0.583,0-1.176-0.152-1.716-0.473 c-1.588-0.95-2.109-3.007-1.159-4.597c4.496-7.537,9.397-14.942,14.571-22.011c1.09-1.493,3.186-1.822,4.686-0.727 c1.493,1.094,1.817,3.191,0.724,4.685c-5.046,6.902-9.833,14.13-14.224,21.488 C1291.775,596.881,1290.662,597.464,1289.519,597.464z M1331.437,543.515c-0.855,0-1.713-0.326-2.367-0.977 c-1.31-1.306-1.316-3.43-0.01-4.741c6.185-6.208,12.737-12.197,19.479-17.801c1.431-1.187,3.54-0.987,4.725,0.435 c1.182,1.424,0.986,3.538-0.436,4.721c-6.585,5.47-12.979,11.316-19.014,17.375 C1333.156,543.186,1332.298,543.515,1331.437,543.515z M1385.237,501.437c-1.14,0-2.25-0.581-2.878-1.629 c-0.953-1.588-0.439-3.648,1.153-4.6c7.505-4.499,15.33-8.7,23.257-12.488c1.663-0.797,3.667-0.092,4.469,1.58 c0.799,1.672,0.092,3.672-1.581,4.471c-7.734,3.697-15.373,7.798-22.701,12.19 C1386.419,501.283,1385.823,501.437,1385.237,501.437z M1447.704,473.785c-1.441,0-2.77-0.935-3.209-2.384 c-0.537-1.773,0.465-3.644,2.24-4.18l0.779-0.237c8.176-2.456,16.516-4.558,24.8-6.257c1.824-0.375,3.589,0.796,3.959,2.611 c0.373,1.814-0.796,3.585-2.61,3.957c-8.094,1.66-16.234,3.713-24.204,6.105l-0.786,0.239 C1448.352,473.738,1448.025,473.785,1447.704,473.785z M1515.017,462.042c-1.775,0-3.258-1.395-3.346-3.188 c-0.092-1.85,1.336-3.423,3.183-3.513c8.798-0.434,17.662-0.454,26.404-0.062c1.85,0.083,3.281,1.65,3.199,3.5 s-1.637,3.271-3.5,3.199c-8.523-0.382-17.187-0.365-25.769,0.061C1515.129,462.04,1515.073,462.042,1515.017,462.042z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M1596.387,470.115c-0.272,0-0.547-0.033-0.822-0.102c-4.25-1.071-8.595-2.056-12.914-2.926 c-1.817-0.367-2.993-2.135-2.626-3.951c0.367-1.814,2.125-2.983,3.949-2.624c4.427,0.892,8.877,1.901,13.228,2.998 c1.798,0.453,2.885,2.276,2.433,4.072C1599.252,469.102,1597.887,470.115,1596.387,470.115z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M1771.163,603.409c-1.172,0-2.308-0.614-2.924-1.708c-2.167-3.849-4.446-7.678-6.774-11.381 c-0.985-1.568-0.514-3.638,1.054-4.623c1.565-0.991,3.634-0.512,4.623,1.054c2.384,3.795,4.718,7.719,6.938,11.66 c0.91,1.614,0.337,3.659-1.277,4.568C1772.286,603.269,1771.719,603.409,1771.163,603.409z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M1528.137,1018.711h-0.003c-8.621-0.01-17.351-0.426-25.946-1.238 c-1.843-0.174-3.199-1.809-3.022-3.652c0.174-1.844,1.804-3.193,3.651-3.024c8.392,0.792,16.912,1.198,25.323,1.208 c1.853,0.002,3.353,1.504,3.35,3.356C1531.487,1017.213,1529.987,1018.711,1528.137,1018.711z M1569.701,1015.62 c-1.631,0-3.062-1.192-3.314-2.854c-0.275-1.83,0.985-3.54,2.816-3.815c8.317-1.252,16.686-2.909,24.875-4.925 c1.827-0.437,3.615,0.656,4.057,2.456c0.442,1.798-0.655,3.615-2.452,4.057c-8.392,2.063-16.964,3.761-25.481,5.043 C1570.035,1015.609,1569.865,1015.62,1569.701,1015.62z M1634.513,997.725c-1.32,0-2.57-0.786-3.101-2.082 c-0.704-1.712,0.115-3.672,1.827-4.374c7.803-3.199,15.536-6.794,22.989-10.686c1.637-0.853,3.667-0.224,4.525,1.419 c0.855,1.642,0.219,3.667-1.421,4.523c-7.636,3.988-15.556,7.67-23.546,10.948 C1635.368,997.643,1634.939,997.725,1634.513,997.725z M1693.166,964.885c-1.031,0-2.05-0.475-2.708-1.372 c-1.094-1.493-0.769-3.592,0.724-4.686c6.784-4.97,13.421-10.321,19.724-15.905c1.385-1.226,3.5-1.102,4.735,0.286 c1.228,1.387,1.097,3.505-0.288,4.733c-6.457,5.72-13.258,11.203-20.209,16.295 C1694.547,964.674,1693.853,964.885,1693.166,964.885z M1742.149,918.889c-0.756,0-1.519-0.255-2.148-0.779 c-1.421-1.187-1.608-3.302-0.422-4.723c5.393-6.454,10.553-13.243,15.34-20.183c1.051-1.524,3.133-1.912,4.666-0.856 c1.522,1.053,1.906,3.14,0.855,4.664c-4.905,7.109-10.19,14.063-15.714,20.674 C1744.061,918.48,1743.109,918.889,1742.149,918.889z M1778.723,862.486c-0.495,0-0.995-0.11-1.47-0.341 c-1.663-0.814-2.351-2.822-1.539-4.486c3.707-7.577,7.102-15.404,10.088-23.262c0.655-1.73,2.59-2.596,4.325-1.943 c1.729,0.656,2.6,2.593,1.942,4.324c-3.058,8.052-6.536,16.069-10.33,23.829 C1781.156,861.795,1779.964,862.486,1778.723,862.486z M1800.798,798.981c-0.236,0-0.475-0.025-0.714-0.077 c-1.811-0.393-2.96-2.177-2.567-3.987c1.788-8.227,3.206-16.638,4.221-25.004c0.226-1.839,1.886-3.143,3.733-2.924 c1.84,0.223,3.15,1.894,2.927,3.733c-1.041,8.57-2.498,17.19-4.325,25.616C1803.732,797.909,1802.341,798.981,1800.798,798.981z  M1806.964,732.021c-1.804,0-3.294-1.434-3.35-3.251c-0.255-8.438-0.907-16.945-1.938-25.283 c-0.229-1.837,1.077-3.512,2.914-3.739c1.837-0.221,3.513,1.077,3.739,2.917c1.057,8.543,1.726,17.257,1.991,25.901 c0.056,1.85-1.401,3.397-3.251,3.453C1807.036,732.021,1807,732.021,1806.964,732.021z M1796.814,665.558 c-1.467,0-2.813-0.973-3.229-2.456c-0.498-1.791-1.015-3.579-1.552-5.367c-1.886-6.29-4.021-12.59-6.352-18.729 c-0.658-1.73,0.213-3.667,1.945-4.325c1.719-0.647,3.667,0.213,4.322,1.945c2.387,6.288,4.578,12.742,6.509,19.182 c0.55,1.829,1.081,3.662,1.591,5.496c0.494,1.784-0.55,3.633-2.335,4.129C1797.416,665.517,1797.112,665.558,1796.814,665.558z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M1461.266,1010.422c-0.272,0-0.544-0.033-0.819-0.1c-4.381-1.098-8.782-2.313-13.074-3.608 c-1.771-0.535-2.777-2.407-2.24-4.18c0.534-1.771,2.394-2.773,4.178-2.241c4.191,1.266,8.487,2.451,12.766,3.523 c1.794,0.45,2.888,2.272,2.436,4.068C1464.135,1009.407,1462.766,1010.422,1461.266,1010.422z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000114074881823097324940000003361392176606440859_",
    gradientUnits: "userSpaceOnUse",
    x1: 1398.881,
    y1: 736.0352,
    x2: 1659.5974,
    y2: 736.0352
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000114074881823097324940000003361392176606440859_)"
    },
    d: "M1529.172,866.391 c-7.236,0-14.453-0.596-21.532-1.778c-0.102-0.016-0.203-0.034-0.305-0.051l1.683-9.918c8.379,1.421,16.961,1.948,25.569,1.567 l0,0c64.455-2.868,114.951-56.221,114.948-120.113c0-1.796-0.039-3.602-0.118-5.412c-2.953-66.267-59.177-117.767-125.53-114.83 c-64.451,2.868-114.948,56.221-114.948,120.113c0,1.798,0.039,3.602,0.118,5.414c0.973,21.789,7.813,42.864,19.78,60.948 l-8.389,5.55c-12.973-19.602-20.386-42.442-21.437-66.051c-0.088-1.965-0.131-3.919-0.131-5.866 c0-69.235,54.72-127.048,124.561-130.157c71.874-3.153,132.829,52.626,136.021,124.43c0.088,1.987,0.134,3.97,0.134,5.946 c-0.003,32.62-12.017,63.611-34.177,87.836c-23.503,25.69-55.601,40.691-90.387,42.24l0,0 C1533.082,866.347,1531.124,866.391,1529.172,866.391z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1829.012,2784.214l412.23-75.03c23.729-4.319,39.647-26.823,35.816-50.636L1984.969,842.897 c-4.144-25.76-29.536-42.382-54.803-35.875L1486.69,921.236c-22.502,5.796-36.707,27.988-32.546,50.849l323.334,1776.467 C1781.861,2772.63,1804.934,2788.596,1829.012,2784.214z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.73
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2009.775,1554.278l30.062,215.887c2.829,20.318-10.704,39.307-30.834,43.262l-287.186,56.428 c-21.156,4.157-41.624-9.796-45.484-31.008l-38.974-214.131c-3.785-20.796,9.837-40.777,30.579-44.853l296.097-58.183 C1985.813,1517.4,2006.714,1532.296,2009.775,1554.278z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1726.687,1902.642l282.663-55.54c21.778-4.28,42.679,10.617,45.74,32.599l30.063,215.881 c2.83,20.318-10.705,39.308-30.834,43.263l-273.752,53.788c-21.156,4.157-41.624-9.796-45.484-31.008l-38.974-214.13 C1692.323,1926.698,1705.945,1906.718,1726.687,1902.642z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1558.835,1193.288l-29.349-161.247c-3.478-19.109,7.763-37.832,26.264-43.744l315.501-100.822 c22.84-7.298,46.746,7.742,50.053,31.49l27.901,200.357c2.829,20.318-10.704,39.307-30.833,43.262l-314.052,61.713 C1583.164,1228.454,1562.696,1214.5,1558.835,1193.288z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1964.46,1228.859l30.061,215.882c2.829,20.318-10.704,39.306-30.833,43.262l-300.619,59.072 c-21.157,4.157-41.625-9.797-45.486-31.009l-38.974-214.13c-3.785-20.796,9.837-40.777,30.578-44.852l309.531-60.824 C1940.497,1191.98,1961.398,1206.877,1964.46,1228.859z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000034056309514119586200000008400953941972482196_",
    gradientUnits: "userSpaceOnUse",
    x1: 245.8955,
    y1: 1248.6534,
    x2: 308.7989,
    y2: 2923.8789,
    gradientTransform: "matrix(-0.9838 0.1791 0.1791 0.9838 1785.3986 -153.0679)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB236D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4C246D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000034056309514119586200000008400953941972482196_)"
    },
    d: "M2100.406,2205.12l21.875,157.083 c2.858,20.525-10.977,39.652-31.365,43.363L1827.5,2453.51c-21.005,3.823-41.131-10.105-44.954-31.109l-27.689-152.127 c-3.785-20.797,9.837-40.778,30.578-44.853l269.23-52.9C2076.444,2168.242,2097.344,2183.138,2100.406,2205.12z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1720.795,2588.256l401.228,120.747c23.096,6.95,47.509-5.847,54.932-28.795l566-1749.729 c8.03-24.824-7.018-51.18-32.479-56.881l-446.88-100.069c-22.675-5.078-45.42,8.222-52.117,30.473l-520.347,1729.051 C1684.079,2556.487,1697.36,2581.203,1720.795,2588.256z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000062901981709979483950000016035178856659533204_",
    gradientUnits: "userSpaceOnUse",
    x1: 2153.8225,
    y1: 2352.6531,
    x2: 2287.9375,
    y2: 1045.0282
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000062901981709979483950000016035178856659533204_)"
    },
    d: "M2441.372,1575.249l-71.455,205.924 c-6.725,19.38-27.417,30.132-47.142,24.495l-281.413-80.418c-20.73-5.924-32.608-27.662-26.395-48.308l62.722-208.414 c6.091-20.242,27.313-31.837,47.637-26.029l290.147,82.909C2436.814,1531.505,2448.648,1554.281,2441.372,1575.249z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000113328618435517724880000015280861838570584220_",
    gradientUnits: "userSpaceOnUse",
    x1: 2085.4429,
    y1: 2345.6399,
    x2: 2219.5579,
    y2: 1038.0148
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000113328618435517724880000015280861838570584220_)"
    },
    d: "M2030.781,1756.662l276.981,79.151 c21.34,6.098,33.175,28.873,25.899,49.84l-71.454,205.921c-6.725,19.38-27.417,30.132-47.142,24.496l-268.248-76.656 c-20.731-5.924-32.609-27.663-26.395-48.308l62.721-208.414C1989.235,1762.449,2010.456,1750.855,2030.781,1756.662z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000108988502346362328490000012422222162449576359_",
    gradientUnits: "userSpaceOnUse",
    x1: 2288.792,
    y1: 2366.4978,
    x2: 2422.907,
    y2: 1058.873
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000108988502346362328490000012422222162449576359_)"
    },
    d: "M2204.06,1048.614l47.23-156.943 c5.598-18.599,24.127-30.157,43.292-27.003l326.826,53.768c23.66,3.893,38.105,28.163,30.244,50.816l-66.315,191.111 c-6.725,19.38-27.417,30.132-47.141,24.496l-307.741-87.937C2209.724,1090.999,2197.846,1069.26,2204.06,1048.614z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000043446734955064328290000015804879460101090961_",
    gradientUnits: "userSpaceOnUse",
    x1: 2222.2019,
    y1: 2359.6658,
    x2: 2356.3169,
    y2: 1052.0403
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000043446734955064328290000015804879460101090961_)"
    },
    d: "M2549.082,1264.846l-71.454,205.92 c-6.725,19.38-27.417,30.132-47.141,24.496l-294.577-84.176c-20.731-5.924-32.609-27.663-26.396-48.308l62.722-208.415 c6.091-20.241,27.312-31.837,47.637-26.029l303.31,86.67C2544.523,1221.102,2556.357,1243.878,2549.082,1264.846z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000126315038038748965180000000901954536651557560_",
    gradientUnits: "userSpaceOnUse",
    x1: 2022.9873,
    y1: 2339.2341,
    x2: 2157.1025,
    y2: 1031.6071
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000126315038038748965180000000901954536651557560_)"
    },
    d: "M2225.952,2196.057l-51.993,149.835 c-6.793,19.577-27.816,30.315-47.659,24.344l-256.386-77.158c-20.443-6.152-32.029-27.713-25.876-48.156l44.56-148.067 c6.091-20.241,27.312-31.836,47.638-26.028l263.818,75.39C2221.393,2152.314,2233.227,2175.089,2225.952,2196.057z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1789.9,2779.687l349.886,230.528c20.14,13.269,47.195,7.995,60.876-11.869L3243.76,1483.798 c14.799-21.488,7.923-51.047-14.841-63.797l-399.547-223.781c-20.273-11.355-45.874-5.121-58.657,14.282l-993.438,1507.801 C1763.812,2738.739,1769.464,2766.222,1789.9,2779.687z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.75
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M2770.26,2015.284l-127.402,176.86c-11.991,16.645-34.894,21.025-52.181,9.98l-246.625-157.595 c-18.167-11.61-23.327-35.838-11.465-53.842l119.746-181.746c11.63-17.652,35.281-22.688,53.094-11.307l254.281,162.481 C2778.41,1972.066,2783.232,1997.275,2770.26,2015.284z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000129165482366249062890000011127897865903420805_",
    gradientUnits: "userSpaceOnUse",
    x1: 2145.7009,
    y1: 2270.1548,
    x2: 2585.511,
    y2: 2270.1548
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000129165482366249062890000011127897865903420805_)"
    },
    d: "M2324.922,2071.598l242.742,155.112 c18.703,11.95,23.524,37.159,10.551,55.168l-127.399,176.855c-11.99,16.645-34.894,21.026-52.181,9.979l-235.088-150.222 c-18.168-11.61-23.328-35.837-11.465-53.841l119.746-181.746C2283.458,2065.251,2307.11,2060.216,2324.922,2071.598z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2693.596,1442.759l90.173-136.86c10.687-16.219,31.748-21.99,49.21-13.484l297.765,145.057 c21.556,10.501,28.451,37.891,14.436,57.346l-118.237,164.137c-11.991,16.645-34.894,21.026-52.18,9.98l-269.701-172.334 C2686.894,1484.992,2681.734,1460.764,2693.596,1442.759z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M2962.301,1748.692l-127.4,176.856c-11.99,16.645-34.893,21.025-52.18,9.98l-258.164-164.963 c-18.168-11.609-23.328-35.838-11.466-53.842l119.746-181.745c11.63-17.652,35.281-22.688,53.094-11.306l265.818,169.853 C2970.452,1705.474,2975.274,1730.683,2962.301,1748.692z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000071519538003742735630000016346228442355509426_",
    gradientUnits: "userSpaceOnUse",
    x1: 2889.8811,
    y1: 1374.7845,
    x2: 2125.8918,
    y2: 2515.6306,
    gradientTransform: "matrix(0.998 -0.0625 0.0625 0.998 -37.9587 62.9046)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3840F7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000071519538003742735630000016346228442355509426_)"
    },
    d: "M2386.174,2548.47l-92.7,128.686 c-12.113,16.814-35.329,21.087-52.634,9.686l-223.578-147.308c-17.828-11.745-22.758-35.72-11.012-53.548l85.073-129.12 c11.63-17.652,35.281-22.688,53.094-11.306l231.205,147.741C2394.325,2505.252,2399.146,2530.461,2386.174,2548.47z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000024692907001926085180000002237395852043722681_",
    gradientUnits: "userSpaceOnUse",
    x1: 1134.5977,
    y1: 2273.667,
    x2: 2512.5161,
    y2: 2273.667
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000024692907001926085180000002237395852043722681_)"
    },
    d: "M1228.539,2263.715l-82.024,65.759 c-22.776,18.256-10.715,57.294,17.663,57.152l1348.338-7.949l-365.029-217.97h-630.382 C1413.156,2160.707,1311.972,2196.824,1228.539,2263.715z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000092451389614506417500000006919666174302161829_",
    gradientUnits: "userSpaceOnUse",
    x1: 1671.614,
    y1: 3336.7466,
    x2: 2137.6643,
    y2: 2357.7046
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000092451389614506417500000006919666174302161829_)"
    },
    d: "M3236.806,2850.219 c-1.178-11.053-2.386-22.125-3.601-33.089c-12.472-112.512-69.892-213.505-157.282-276.362l-6.77-4.865 c-105.258-75.704-226.18-122.274-352.08-135.59l-204.557-21.636l-1348.338,7.949c-28.378,0.141-40.439-38.896-17.663-57.152 l82.024-65.759c83.433-66.891,184.617-103.008,288.566-103.008h630.382l-4.727-2.127 c-37.878-17.044-78.511-25.821-119.551-25.821h-593.644c-36.069,0-71.933,5.832-106.401,17.293l-446.498,178.266 c-22.066,7.343-41.765,21.247-56.836,40.118l-92.234,115.498c-19.198,24.04-29.757,54.716-29.757,86.448v188.211 c0,49.813,163.284,220.014,163.284,220.014c17.785,9.771,37.46,14.865,57.418,14.865h2005.835l213.033-14.973 C3198.42,2974.206,3243.793,2915.744,3236.806,2850.219z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000182505320182241411420000009808542857523769990_",
    gradientUnits: "userSpaceOnUse",
    x1: 3316.6714,
    y1: 2751.3469,
    x2: 2909.5605,
    y2: 3198.2512
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000182505320182241411420000009808542857523769990_)"
    },
    d: "M3229.723,2935.477h-6.376 c-12.415,0-22.479-10.857-22.479-24.251v-121.864c0-13.394,10.064-24.251,22.479-24.251l0,0 c11.923,0,21.772,10.042,22.443,22.884l6.376,121.864C3252.894,2923.768,3242.635,2935.477,3229.723,2935.477z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000064334838748142852230000015717038767722316464_",
    gradientUnits: "userSpaceOnUse",
    x1: 3216.0439,
    y1: 2521.1128,
    x2: 2469.2344,
    y2: 3511.1484
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000064334838748142852230000015717038767722316464_)"
    },
    d: "M3150.618,2741.723h66.932 c-24.913-81.485-74.33-152.55-141.628-200.955l-6.77-4.865c-6.975-5.015-14.028-9.884-21.137-14.645 c13.664,51.424,30.511,121.939,41.604,169.265C3096.685,2720.664,3121.8,2741.723,3150.618,2741.723z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000178894665167797073260000012868300528522124467_",
    gradientUnits: "userSpaceOnUse",
    x1: 939.8341,
    y1: 2606.6021,
    x2: 1583.8724,
    y2: 3305.4519
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000178894665167797073260000012868300528522124467_)"
    },
    d: "M876.667,2467.679v-139.36 c-22.066,7.343-41.765,21.247-56.836,40.118l-92.234,115.498c-16.027,20.069-25.929,44.785-28.798,70.859l125.906-21.491 C854.63,2528.198,876.667,2500.364,876.667,2467.679z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000158723084469550388600000002262729163515861896_",
    gradientUnits: "userSpaceOnUse",
    x1: 2614.9648,
    y1: 1291.7599,
    x2: 1951.1272,
    y2: 2830.6597
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000158723084469550388600000002262729163515861896_)"
    },
    d: "M2290.963,2372.548l-47.407-49.696 c-19.755-20.708-44.617-34.844-71.618-40.718l-93.764-20.398c-25.731-5.598-50.359,13.862-53.175,42.017l-0.662,6.613 c-2.868,28.678,18.129,53.62,44.863,53.292l120.796-1.481c16.846-0.207,32.155,10.538,38.808,27.235l2.225,5.585 c2.953,7.412,9.713,12.215,17.191,12.215h29.703C2294.724,2407.213,2303.012,2385.178,2290.963,2372.548z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000163756354662214217930000016817600655919917473_",
    gradientUnits: "userSpaceOnUse",
    x1: 2624.4312,
    y1: 1431.6129,
    x2: 2302.5544,
    y2: 1907.7225
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000163756354662214217930000016817600655919917473_)"
    },
    d: "M1805.236,2462.57h206.75 c16.127,0,27.495,17.29,21.904,33.608c-9.46,27.609-31.991,62.824-85.545,66.937c-48.163,3.699-108.871-25.722-154.66-53.677 C1772.927,2496.766,1781.384,2462.57,1805.236,2462.57z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000129899367873032021650000006018361103704962989_",
    gradientUnits: "userSpaceOnUse",
    x1: 923.5535,
    y1: 2943.8,
    x2: 1469.4122,
    y2: 2943.8
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000129899367873032021650000006018361103704962989_)"
    },
    cx: 1196.483,
    cy: 2943.8,
    r: 272.929
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000143603624447317231930000010588842032730415239_",
    gradientUnits: "userSpaceOnUse",
    x1: 974.8352,
    y1: 2943.8003,
    x2: 1418.1309,
    y2: 2943.8003
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      opacity: 0.41,
      fill: "url(#SVGID_00000143603624447317231930000010588842032730415239_)"
    },
    cx: 1196.483,
    cy: 2943.8,
    r: 221.648
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000170975524412412902200000013997619461228352690_",
    gradientUnits: "userSpaceOnUse",
    x1: 2533.269,
    y1: 2943.8,
    x2: 3079.1287,
    y2: 2943.8
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000170975524412412902200000013997619461228352690_)"
    },
    cx: 2806.199,
    cy: 2943.8,
    r: 272.93
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000024715629175253922670000001757907920341711802_",
    gradientUnits: "userSpaceOnUse",
    x1: 2584.5508,
    y1: 2943.8003,
    x2: 3027.8469,
    y2: 2943.8003
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      opacity: 0.41,
      fill: "url(#SVGID_00000024715629175253922670000001757907920341711802_)"
    },
    cx: 2806.199,
    cy: 2943.8,
    r: 221.648
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M2987.02,3023.541c-0.439,0-0.881-0.087-1.306-0.267c-1.706-0.72-2.502-2.688-1.781-4.394 c10.059-23.778,15.157-49.038,15.157-75.08c0-106.359-86.53-192.889-192.889-192.889c-32.995,0-65.555,8.472-94.159,24.503 c-1.624,0.904-3.664,0.326-4.564-1.287c-0.907-1.616-0.331-3.659,1.284-4.564c29.606-16.589,63.299-25.358,97.44-25.358 c110.056,0,199.595,89.537,199.595,199.595c0,26.944-5.278,53.083-15.687,77.693 C2989.567,3022.771,2988.326,3023.539,2987.02,3023.541z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M1382.66,3023.541c-0.439,0-0.881-0.087-1.307-0.267c-1.706-0.72-2.502-2.688-1.781-4.394 c10.059-23.778,15.157-49.038,15.157-75.08c0-106.359-86.53-192.889-192.893-192.889c-32.995,0-65.555,8.472-94.156,24.503 c-1.627,0.904-3.664,0.326-4.564-1.287c-0.907-1.614-0.331-3.659,1.284-4.564c29.603-16.589,63.296-25.358,97.437-25.358 c110.059,0,199.598,89.537,199.598,199.595c0,26.944-5.278,53.083-15.687,77.693 C1385.208,3022.771,1383.967,3023.539,1382.66,3023.541z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.77,
      fill: "#FFFFFF"
    },
    d: "M1526.733,2859.197c-1.578,0-2.986-1.118-3.291-2.726 c-24.286-127.698-97.063-208.968-216.313-241.552c-89.228-24.384-172.464-10.8-173.286-10.659 c-1.873,0.319-3.559-0.923-3.867-2.747c-0.308-1.825,0.923-3.556,2.747-3.864c0.848-0.143,85.332-13.963,175.961,10.743 c83.914,22.878,190.43,84.269,221.346,246.825c0.347,1.821-0.848,3.575-2.668,3.921 C1527.152,2859.179,1526.939,2859.197,1526.733,2859.197z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.77,
      fill: "#FFFFFF"
    },
    d: "M2472.846,2900.782c-1.801,0-3.291-1.432-3.346-3.248 c-3.147-100.451,23.755-179.121,79.958-233.828c92.791-90.323,235.174-83.126,236.598-83.044c1.847,0.108,3.258,1.694,3.15,3.543 c-0.105,1.848-1.745,3.222-3.54,3.153c-1.401-0.072-140.936-7.073-231.572,81.191c-54.769,53.337-80.977,130.309-77.896,228.775 c0.059,1.85-1.395,3.399-3.245,3.456C2472.918,2900.782,2472.882,2900.782,2472.846,2900.782z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1172.787,2355.83c-1.166,0-2.299-0.609-2.917-1.694c-0.917-1.609-0.354-3.657,1.257-4.573 l182.811-104.016c51.94-29.554,110.979-45.742,170.732-46.816l209.699-3.764c1.794,0.059,3.379,1.442,3.412,3.292 c0.033,1.852-1.441,3.379-3.294,3.413l-209.699,3.764c-58.633,1.053-116.565,16.938-167.536,45.938l-182.811,104.016 C1173.92,2355.69,1173.35,2355.83,1172.787,2355.83z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000118361261759660152790000016614984648265146754_",
    gradientUnits: "userSpaceOnUse",
    x1: 69.3602,
    y1: 1347.5215,
    x2: 282.028,
    y2: 1911.0918,
    gradientTransform: "matrix(-0.9869 0.1614 0.1614 0.9869 1222.7954 575.3264)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000118361261759660152790000016614984648265146754_)"
    },
    d: "M1442.195,2003.778l-34.585,47.411 c-59.462,3.949-107.556-6.882-145.985-24.318c12.368-55.266,28.515-89.491,42.205-110.236 C1370.87,1984.37,1442.195,2003.778,1442.195,2003.778z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000109011267936405670080000004410673757279845549_",
    gradientUnits: "userSpaceOnUse",
    x1: 2453.5632,
    y1: 1738.5535,
    x2: 2132.083,
    y2: 1991.9053,
    gradientTransform: "matrix(-1 0 0 1 3501.6965 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000109011267936405670080000004410673757279845549_)"
    },
    d: "M1130.258,1898.568l72.434-168.087 c20.424,84.788,59.975,144.563,101.138,186.154c-13.69,20.746-29.838,54.971-42.205,110.236 C1165.724,1983.363,1130.258,1898.568,1130.258,1898.568z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1054.677,3208.372c49.167,2.262,96.758,0.841,128.534-0.792 c-28.932-20.593-95.585-65.396-151.359-83.234l-38.287-2.291c0,0-12.974,19.731-17.603,64.883 C982.307,3194.855,1000.854,3205.895,1054.677,3208.372z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000112602672438570300680000004614896712429488047_",
    gradientUnits: "userSpaceOnUse",
    x1: 1085.8558,
    y1: 3070.4905,
    x2: 1072.1528,
    y2: 3437.0447
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000112602672438570300680000004614896712429488047_)"
    },
    d: "M1183.607,3207.86 c-0.126-0.09-0.268-0.189-0.396-0.281c-31.776,1.634-79.367,3.055-128.534,0.792c-53.823-2.477-72.369-13.516-78.715-21.433 c-0.213,2.08-0.432,4.146-0.607,6.335c-0.795,9.909,6.56,18.609,16.471,19.358c40.267,3.045,140.106,9.939,188.253,7.414 C1186.429,3219.712,1188.785,3211.551,1183.607,3207.86z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M710.5,3195.213c-3.601-23.082-9.375-56.452-13.835-64.982c-6.999-13.384-30.956,0-30.956,0 s-16.819,7.843-24.559,20.915c-4.934,8.333-18.58,32.041-27.826,48.137c-1.064,1.852-1.507,3.822-1.451,5.731l95.931,3.357 C710.147,3204.608,711.249,3200.019,710.5,3195.213z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000145055324483955969280000012656514251105033096_",
    gradientUnits: "userSpaceOnUse",
    x1: 691.5875,
    y1: 2970.8284,
    x2: 619.6476,
    y2: 3505.2397
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000145055324483955969280000012656514251105033096_)"
    },
    d: "M611.871,3205.014 c0.16,5.48,4.503,10.45,10.631,10.619l68.344,1.88c7.222,0.2,13.474-3.553,16.956-9.142L611.871,3205.014z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000041277358499648357540000017943089462892202135_",
    gradientUnits: "userSpaceOnUse",
    x1: 1979.3118,
    y1: -944.7051,
    x2: 2477.4983,
    y2: -1755.8561,
    gradientTransform: "matrix(-1 0 0 1 1267.5382 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000041277358499648357540000017943089462892202135_)"
    },
    d: "M1277.269,1710.577 c-61.173-16.025-174.013-41.12-263.841-35.764c-20.631,1.23-37.164,17.542-38.334,38.176 c-13.57,239.238-32.113,451.535-67.032,575.056c78.491,31.06,156.304,45.467,233.072,34.187 c57.511-123.184,107.793-265.397,150.755-426.9c0,0,25.205-128.815,0.73-171.751 C1288.804,1716.889,1283.782,1712.283,1277.269,1710.577z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000142155231714843679380000008149017238743160752_",
    gradientUnits: "userSpaceOnUse",
    x1: 8917.9561,
    y1: 1764.4869,
    x2: 8944.2959,
    y2: 1602.0554,
    gradientTransform: "matrix(1 0 0 1 -7765.9043 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000142155231714843679380000008149017238743160752_)"
    },
    d: "M1130.128,1542.99 c0,0-15.446,92.157-20.052,134.775c-0.748,6.925,2.874,13.474,9.068,16.662c16.884,8.692,52.925,22.69,92.197,9.843 c6.468-2.116,10.708-8.373,10.559-15.176l-2.693-123.031L1130.128,1542.99z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000142152029383214194070000006105249820967050164_",
    gradientUnits: "userSpaceOnUse",
    x1: 9003.0264,
    y1: 1501.1478,
    x2: 8832.6436,
    y2: 1631.5167,
    gradientTransform: "matrix(1 0 0 1 -7765.9043 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000142152029383214194070000006105249820967050164_)"
    },
    d: "M1230.875,1440.883 c0,0,29.805,68.466,31.806,104.401c2.001,35.935,9.745,59.253-31.806,66.49c-41.551,7.237-76.554-13.463-95.517-49.258 c0,0-29.711-55.158-23.046-77.746S1230.875,1440.883,1230.875,1440.883z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000155861413047544522880000009363713456588483518_",
    gradientUnits: "userSpaceOnUse",
    x1: 8874.874,
    y1: 1404.7994,
    x2: 9029.1582,
    y2: 1603.4402,
    gradientTransform: "matrix(1 0 0 1 -7765.9043 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000155861413047544522880000009363713456588483518_)"
    },
    d: "M1149.556,1536.779h5.253 c0,0-21.643-44.393-2.627-52.193c19.016-7.799,77.218-7.709,93.47-34.437c15.668-25.768-25.716-41.595-46.622-50.91 c-1.323-0.589,24.861-3.988,24.184-2.707l4.307-3.2c-1.186,2.245-14.924-8.392-15.63-10.83 c-0.669-2.313-16.943-12.259-18.215-10.215c-4.975,7.993,15.889,18.317-20.242,24.985 c-51.268,9.462-85.162,30.211-85.995,65.643c-0.053,2.244-2.452,3.482-4.369,2.313c-3.785-2.306,11.256-3.381,3.162,3.426 c-5.786,4.866-9.465,10.552-10.342,18.122c-1.023,8.833,5.566,19.698,11.725,25.51c3.636,3.431,5.611,7.962,5.51,12.964 c-0.104,5.138-3.089,9.282-3.7,14.243c-0.784,6.363,5.537,10.75,10.376,13.531c6.764,3.887,13.467,7.894,19.925,12.274 c3.621,2.456,10.869,10.011,15.618,8.796c1.328-0.34,2.221-1.551,2.137-2.919l-1.94-31.399c-0.1-1.624,1.19-2.996,2.817-2.996 H1149.556z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000121271425932307340880000017538421176033864069_",
    gradientUnits: "userSpaceOnUse",
    x1: 8981.8926,
    y1: 1473.527,
    x2: 8811.5098,
    y2: 1603.896,
    gradientTransform: "matrix(1 0 0 1 -7765.9043 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000121271425932307340880000017538421176033864069_)"
    },
    d: "M1150.847,1543.348 c0,0-11.37-43.734-30.979-31.472c-19.609,12.262,10.175,49.003,25.94,50.64L1150.847,1543.348z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000079466412604382114760000000656171402860298645_",
    gradientUnits: "userSpaceOnUse",
    x1: 4.5628,
    y1: -119.9407,
    x2: -76.6148,
    y2: -482.8527,
    gradientTransform: "matrix(-1 0 0 1 1267.5382 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000079466412604382114760000000656171402860298645_)"
    },
    d: "M816.794,2029.207 c-30.252,84.874-13.215,175.87-13.215,175.87l-39.876,10.634c0,0-51.516-61.272-39.731-197.236 C760.78,2012.858,795.256,2021.483,816.794,2029.207z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000111154842659755043930000015802940865644097939_",
    gradientUnits: "userSpaceOnUse",
    x1: 2081.7312,
    y1: -881.7953,
    x2: 2579.9187,
    y2: -1692.9476,
    gradientTransform: "matrix(-1 0 0 1 1267.5382 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000111154842659755043930000015802940865644097939_)"
    },
    d: "M723.973,2018.475 c1.324-15.288,3.409-31.472,6.499-48.668c26.944-149.954,219.188-265.302,264.424-290.562c4.206-2.349,9.325,0.821,9.173,5.636 l-6.425,203.844c-107.067,14.391-157.742,75.652-180.85,140.482C795.256,2021.483,760.78,2012.858,723.973,2018.475z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000125572867087419214150000007028587833541838264_",
    gradientUnits: "userSpaceOnUse",
    x1: -90.5545,
    y1: 1360.564,
    x2: 122.1233,
    y2: 1924.1608,
    gradientTransform: "matrix(-0.9869 0.1614 0.1614 0.9869 1222.7954 575.3264)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000125572867087419214150000007028587833541838264_)"
    },
    d: "M1540.471,2019.517 c7.04-3.243,12.179-9.47,14.154-16.966c3.827-14.526,7.085-37.325-8.529-41.554c-23.254-6.297-56.008,40.477-56.008,40.477 l-14.13,34.309l-16.186,11.43C1476.609,2049.011,1506.461,2036.542,1540.471,2019.517z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000025432606554808141830000006097862602096693397_",
    gradientUnits: "userSpaceOnUse",
    x1: 1183.2557,
    y1: 1093.8022,
    x2: 1193.5327,
    y2: 1511.7417
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000025432606554808141830000006097862602096693397_)"
    },
    d: "M1081.032,1502.116 c24.369-6.651,48.725-13.391,73.022-20.315c41.475-11.819,83.642-22.261,124.589-35.795c8.717-2.881,17.422-5.653,26.226-8.253 c5.279-1.559,11.837-4.204,15.396-8.605c3.875-4.79,2.241-12.038-4.43-12.277c-11.473-0.411-23.344,1.162-34.597,3.119 c-3.241,0.564-35.304,6.61-35.218,7.206c-0.007-0.053-12.202-84.226-107.437-54.881 C1023.84,1407.675,1066.779,1509.707,1081.032,1502.116z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000004520670952065202680000005444262419944769932_",
    gradientUnits: "userSpaceOnUse",
    x1: 1473.0409,
    y1: 1514.1693,
    x2: 261.0307,
    y2: 4426.0088
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000004520670952065202680000005444262419944769932_)"
    },
    d: "M1141.135,2324.733 c-2.374,12.397-86.132,536.679-91.214,807.969c-0.085,4.548-3.204,8.364-7.403,8.991c-10.634,1.591-31.341,3.636-51.419-0.359 c-2.75-0.547-4.822-2.977-4.995-5.972c-2.927-50.556-26.47-478.003,2.362-679.222c0,0-238.153,537.889-274.253,686.205 c-0.879,3.608-3.965,6.035-7.435,5.839c-10.201-0.578-31.411-2.547-48.254-9.199c-6.037-2.385-9.475-9.193-7.951-15.9 c20.169-88.761,161.518-700.302,257.49-835.04L1141.135,2324.733z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000052080823314280891180000006866052652481508253_",
    gradientUnits: "userSpaceOnUse",
    x1: 8891.2783,
    y1: 2271.9883,
    x2: 8672.4512,
    y2: 2554.8999,
    gradientTransform: "matrix(1 0 0 1 -7765.9043 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5AB6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2F68E3"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.25,
      fill: "url(#SVGID_00000052080823314280891180000006866052652481508253_)"
    },
    d: "M988.466,2447.808 c-0.789,0-1.578-0.296-2.186-0.892c-1.234-1.206-1.256-3.187-0.049-4.421l31.89-32.61c1.207-1.236,3.186-1.254,4.421-0.049 c1.234,1.206,1.256,3.188,0.049,4.42l-31.89,32.61C990.088,2447.494,989.277,2447.808,988.466,2447.808z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000183223998470415061380000010063942840988476293_",
    gradientUnits: "userSpaceOnUse",
    x1: 1343.6973,
    y1: 1460.3317,
    x2: 131.6882,
    y2: 4372.1685
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000183223998470415061380000010063942840988476293_)"
    },
    d: "M1137.722,2330.313l87.101-206.272 l14.426-232.749l-177.974-16.103c-39.038,69.499-79.417,133.378-123.057,183.6c-1.831,2.107-3.148,4.588-3.845,7.291 l-55.688,215.883L1137.722,2330.313z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000130635750745678317940000015306640473004691604_",
    gradientUnits: "userSpaceOnUse",
    x1: 1371.9877,
    y1: 1472.1068,
    x2: 159.9787,
    y2: 4383.9429
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000130635750745678317940000015306640473004691604_)"
    },
    d: "M1239.248,1891.293 c18.871-54.614,25.315-111.415,38.021-180.716c-17.748-11.212-23.937-16.488-41.014-12.656 c-11.648,69.505-23.841,135.321-39.122,195.945L1239.248,1891.293z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000148656374475473537580000009480348425576361095_",
    gradientUnits: "userSpaceOnUse",
    x1: 1219.5365,
    y1: 1408.6516,
    x2: 7.53,
    y2: 4320.4819
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000148656374475473537580000009480348425576361095_)"
    },
    d: "M1097.457,1878.676 c-0.262-67.357-1.106-135.577-15.123-204.599c-22.128-4.061-31.672-5.788-46.838,0c16.958,73.532,17.167,145.828,25.779,211.707 L1097.457,1878.676z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M574.369,2337.37l1079.277-594.16l64.65,106.306L694.249,2534.492 c-2.284,1.528-4.604,3.007-6.952,4.436l-35.474,21.573c-60.872,37.02-130.451,33.758-155.413-7.286l-29.675-48.795 c-24.961-41.043,4.151-104.324,65.023-141.344l35.474-21.574C569.581,2340.074,571.962,2338.697,574.369,2337.37z  M547.07,2488.985c16.561,27.232,67.139,26.714,112.969-1.157c45.83-27.871,69.556-72.542,52.995-99.774 c-16.561-27.232-67.139-26.712-112.968,1.159C554.237,2417.084,530.509,2461.753,547.07,2488.985z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1980.444,1471.042l-205.833,125.178c-14.655,8.912-24.344,24.123-26.225,41.172l-9.645,87.397 c-2.753,24.946,11.642,48.616,35.059,57.647l82.036,31.639c16.004,6.172,33.966,4.566,48.621-4.346l205.834-125.178 c31.047-18.881,70.477,7.448,64.092,43.22c-15.275,85.577-67.054,165.492-148.952,215.299 c-148.024,90.021-320.044,36.525-406.632-105.854c-86.588-142.379-54.955-319.727,93.069-409.748 c81.898-49.806,176.674-59.018,259.686-33.214C2006.252,1405.039,2011.491,1452.161,1980.444,1471.042z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000086684946992107466110000005406150510820970881_",
    gradientUnits: "userSpaceOnUse",
    x1: 3373.3181,
    y1: -2593.1526,
    x2: 3665.7473,
    y2: -1625.4774,
    gradientTransform: "matrix(-0.5196 -0.8544 -0.8544 0.5196 695.7816 6120.5117)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000086684946992107466110000005406150510820970881_)"
    },
    d: "M1992.242,1490.441l-205.834,125.178 c-14.656,8.913-24.344,24.123-26.225,41.172l-9.645,87.396c-2.753,24.946,11.642,48.616,35.058,57.647l82.036,31.639 c16.004,6.172,33.966,4.567,48.621-4.346l205.834-125.178c31.047-18.881,70.477,7.448,64.092,43.22 c-15.275,85.577-67.054,165.493-148.952,215.298c-148.024,90.021-320.045,36.525-406.632-105.854 c-86.588-142.379-54.955-319.727,93.069-409.748c81.897-49.806,176.674-59.018,259.686-33.214 C2018.049,1424.438,2023.289,1471.56,1992.242,1490.441z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000002379661209244574430000007249061636266820254_",
    gradientUnits: "userSpaceOnUse",
    x1: 3212.3987,
    y1: -1511.8656,
    x2: 3504.8374,
    y2: -544.1594,
    gradientTransform: "matrix(-0.5196 -0.8544 -1.059 0.6441 911.548 5989.7534)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000002379661209244574430000007249061636266820254_)"
    },
    d: "M583.779,2352.844l1079.277-594.161 l64.65,106.306L703.659,2549.966c-2.284,1.528-4.603,3.007-6.952,4.436l-35.474,21.574 c-60.872,37.019-130.452,33.757-155.413-7.286l-29.675-48.795c-24.961-41.044,4.151-104.325,65.023-141.344l35.474-21.574 C578.992,2355.549,581.373,2354.17,583.779,2352.844z M556.481,2504.458c16.561,27.232,67.139,26.714,112.969-1.157 c45.83-27.871,69.557-72.542,52.995-99.773c-16.561-27.231-67.138-26.713-112.968,1.159 C563.647,2432.558,539.92,2477.227,556.481,2504.458z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000119096251783851986790000003104667624511190459_",
    gradientUnits: "userSpaceOnUse",
    x1: 383.2798,
    y1: 2132.6638,
    x2: 625.3027,
    y2: 2482.252,
    gradientTransform: "matrix(-1 0 0 1 1267.5382 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000119096251783851986790000003104667624511190459_)"
    },
    d: "M800.918,2185.139h49.301 c0,0-39.995,23.985-41.323,49.21c-1.329,25.225,15.878,77.475,23.925,91.699c8.801,15.555-111.638-23.163-69.119-140.909H800.918 z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000079485448422881768460000015902718104176925578_",
    gradientUnits: "userSpaceOnUse",
    x1: 1819.7369,
    y1: 2849.2913,
    x2: 1849.9712,
    y2: 2663.1121
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000079485448422881768460000015902718104176925578_)"
    },
    d: "M1969.459,2828.957h-40.235v-105.755 c0-7.74-5.217-11.596-12.957-11.596H1745.65c-7.74,0-14.246,3.855-14.246,11.596v105.755h-36.882v-105.755 c0-29.176,21.951-48.477,51.127-48.477h170.617c29.176,0,53.192,19.301,53.192,48.477V2828.957z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000168803791366338121280000001415208846189057165_",
    gradientUnits: "userSpaceOnUse",
    x1: 1828.7985,
    y1: 2538.7185,
    x2: 1828.7985,
    y2: 3125.9363
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000168803791366338121280000001415208846189057165_)"
    },
    d: "M1511.32,2832.327l17.467,323.412 c1.607,29.76,26.119,53.101,55.922,53.271l477.445,2.707c29.393,0.167,53.972-22.27,56.445-51.559l27.677-327.831H1511.32z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2184.043,2802.287c0-9.343-7.574-16.917-16.917-16.917h-666.918 c-9.343,0-16.917,7.574-16.917,16.917v49.987c0,9.343,7.574,16.917,16.917,16.917h666.918c9.343,0,16.917-7.574,16.917-16.917 V2802.287z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1660.37,2906.052c-0.624,5.007-4.983,10.08-9.741,10.08h-74.668 c-4.758,0-8.534-5.073-8.432-10.08l1.09-51.838c0.116-5.696,4.388-8.493,9.541-8.493h80.869c5.153,0,8.749,2.797,8.038,8.493 L1660.37,2906.052z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1971.7,2906.052c0.624,5.007,4.983,10.08,9.741,10.08h74.668c4.758,0,8.534-5.073,8.432-10.08 l-1.09-51.838c-0.116-5.696-4.388-8.493-9.542-8.493h-80.869c-5.154,0-8.749,2.797-8.039,8.493L1971.7,2906.052z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M1701.315,3167.399c-0.776,0-1.562-0.146-2.318-0.445l-16.611-6.565 c-2.475-0.972-4.067-3.422-3.952-6.09l0.534-12.157c-4.568-3.445-8.683-7.429-12.285-11.891l-12.161,0.933 c-2.619,0.208-5.141-1.293-6.208-3.729l-7.125-16.403c-1.061-2.472-0.442-5.326,1.532-7.118l8.972-8.202 c-0.796-5.674-0.894-11.395-0.295-17.069l-9.256-7.924c-2.033-1.748-2.731-4.582-1.742-7.063l6.555-16.591 c0.966-2.47,3.359-4.054,6.094-3.949l12.174,0.544c3.445-4.558,7.426-8.666,11.882-12.258l-0.94-12.139 c-0.219-2.651,1.29-5.159,3.752-6.223l16.394-7.094c2.43-1.056,5.285-0.454,7.089,1.508l8.241,8.999 c5.684-0.792,11.404-0.884,17.098-0.28l7.921-9.239c1.739-2.03,4.574-2.728,7.059-1.739l16.61,6.565 c2.482,0.982,4.067,3.43,3.952,6.092l-0.534,12.156c4.568,3.445,8.683,7.429,12.285,11.891l12.161-0.933 c2.633-0.193,5.164,1.306,6.218,3.756l7.115,16.376c1.061,2.467,0.445,5.318-1.526,7.112l-8.978,8.209 c0.796,5.674,0.894,11.395,0.295,17.069l9.256,7.924c2.033,1.748,2.731,4.582,1.742,7.063l-6.555,16.593 c-0.972,2.48-3.399,4.047-6.106,3.947l-12.161-0.544c-3.445,4.558-7.426,8.666-11.882,12.259l0.94,12.138 c0.219,2.651-1.29,5.159-3.752,6.223l-16.394,7.094c-2.433,1.058-5.285,0.455-7.089-1.508l-8.241-9 c-5.678,0.794-11.401,0.887-17.098,0.28l-7.921,9.238C1704.851,3166.628,1703.106,3167.399,1701.315,3167.399z  M1698.427,3158.66c-0.006,0.007-0.013,0.013-0.02,0.021L1698.427,3158.66z M1702.687,3157.596l0.02,0.008 C1702.7,3157.601,1702.694,3157.597,1702.687,3157.596z M1742.414,3156.972l-0.013,0.005L1742.414,3156.972z M1688.604,3152.031 l11.581,4.576l9.728-11.342l2.744,0.406c6.447,0.949,12.973,0.845,19.404-0.316l2.731-0.493l10.108,11.034l11.414-4.939 l-1.156-14.906l2.233-1.657c5.242-3.892,9.78-8.574,13.49-13.917l1.585-2.281l14.937,0.668l4.568-11.557l-11.362-9.725 l0.403-2.747c0.946-6.427,0.835-12.948-0.331-19.381l-0.498-2.734l11.034-10.088l-4.954-11.411l-14.924,1.146l-1.657-2.227 c-3.9-5.244-8.589-9.782-13.942-13.492l-2.282-1.582l0.655-14.929l-11.581-4.576l-9.728,11.342l-2.744-0.406 c-6.437-0.949-12.966-0.845-19.407,0.316l-2.727,0.493l-10.108-11.034l-11.414,4.939l1.156,14.908l-2.233,1.657 c-5.242,3.888-9.78,8.571-13.49,13.916l-1.585,2.281l-14.937-0.668l-4.568,11.557l11.362,9.725l-0.403,2.747 c-0.946,6.427-0.835,12.948,0.331,19.381l0.498,2.734l-11.034,10.09l4.954,11.409l14.924-1.146l1.657,2.227 c3.9,5.244,8.589,9.782,13.942,13.492l2.282,1.582L1688.604,3152.031z M1756.523,3153.655c0.003,0.011,0.003,0.021,0.003,0.031 L1756.523,3153.655z M1686.07,3151.029l0.016,0.007C1686.087,3151.036,1686.077,3151.032,1686.07,3151.029z M1786.408,3121.384 c-0.003,0.007-0.003,0.013-0.007,0.02L1786.408,3121.384z M1653.759,3121.155h-0.013H1653.759z M1790.098,3118.985h0.02 C1790.118,3118.985,1790.104,3118.985,1790.098,3118.985z M1649.516,3111.351l-0.023,0.02 C1649.503,3111.365,1649.509,3111.358,1649.516,3111.351z M1792.966,3104.783c0,0.007-0.003,0.015-0.007,0.021 L1792.966,3104.783z M1649.758,3067.366l-0.007,0.021C1649.751,3067.381,1649.755,3067.374,1649.758,3067.366z  M1793.225,3060.801c-0.003,0.002-0.007,0.005-0.01,0.008L1793.225,3060.801z M1656.32,3050.764l-0.013,0.028 C1656.313,3050.781,1656.317,3050.772,1656.32,3050.764z M1785.183,3048.738c0.003,0.005,0.006,0.012,0.006,0.017 L1785.183,3048.738z M1686.191,3018.484l0.003,0.031C1686.191,3018.503,1686.191,3018.494,1686.191,3018.484z  M1700.317,3015.193l-0.013,0.005C1700.303,3015.198,1700.31,3015.195,1700.317,3015.193z M1740.011,3014.566 c0.006,0.003,0.013,0.007,0.013,0.007L1740.011,3014.566z M1744.31,3013.489l-0.013,0.013 C1744.3,3013.497,1744.307,3013.494,1744.31,3013.489z M1740.479,3010.229h0.033H1740.479z M1721.004,3134.388 c-5.887,0-11.866-1.085-17.662-3.376c-24.705-9.762-36.865-37.779-27.115-62.451c4.722-11.953,13.824-21.348,25.625-26.456 c11.804-5.103,24.888-5.313,36.855-0.586c3.193,1.261,6.247,2.86,9.083,4.751c2.308,1.541,2.934,4.664,1.392,6.974 c-1.542,2.31-4.666,2.935-6.977,1.392c-2.24-1.496-4.663-2.762-7.194-3.762c-9.473-3.744-19.826-3.577-29.161,0.463 c-9.335,4.039-16.535,11.468-20.271,20.921c-7.711,19.515,1.915,41.675,21.46,49.399c19.538,7.723,41.721-1.876,49.432-21.386 c2.534-6.414,3.281-13.382,2.158-20.15c-0.455-2.741,1.398-5.331,4.139-5.786c2.711-0.445,5.331,1.398,5.782,4.139 c1.421,8.569,0.478,17.383-2.728,25.494C1758.36,3122.851,1740.191,3134.388,1721.004,3134.388z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M1908.746,3139.009c-0.19,0-0.38-0.008-0.573-0.025l-25.065-2.169 c-2.868-0.252-5.265-2.292-5.966-5.08l-4.463-17.699c-8.12-2.919-15.772-6.887-22.812-11.832l-17,6.542 c-2.685,1.038-5.737,0.25-7.59-1.951l-16.211-19.258c-1.853-2.199-2.109-5.339-0.632-7.811l9.345-15.641 c-3.671-7.783-6.277-16-7.767-24.494l-16.679-7.415c-2.626-1.166-4.23-3.877-3.985-6.743l2.135-25.063 c0.242-2.873,2.289-5.275,5.085-5.974l17.678-4.437c2.908-8.119,6.866-15.764,11.794-22.792l-6.562-17.018 c-1.038-2.687-0.255-5.741,1.955-7.596l19.227-16.185c2.21-1.853,5.347-2.104,7.816-0.627l15.648,9.368 c7.77-3.661,15.979-6.256,24.472-7.736l7.387-16.665c1.166-2.631,3.923-4.23,6.742-3.991l25.068,2.169 c2.868,0.252,5.265,2.292,5.966,5.08l4.463,17.699c8.12,2.919,15.772,6.887,22.812,11.832l17-6.542 c2.685-1.033,5.733-0.247,7.587,1.947l16.214,19.263c1.85,2.21,2.102,5.344,0.635,7.808l-9.348,15.645 c3.671,7.783,6.277,16,7.767,24.493l16.679,7.413c2.629,1.174,4.23,3.883,3.985,6.745l-2.135,25.063 c-0.242,2.873-2.289,5.275-5.085,5.974l-17.678,4.437c-2.907,8.119-6.866,15.764-11.794,22.792l6.562,17.018 c1.038,2.687,0.255,5.741-1.955,7.596l-19.227,16.185c-2.204,1.858-5.34,2.105-7.816,0.627l-15.648-9.368 c-7.77,3.661-15.979,6.256-24.472,7.736l-7.387,16.666C1913.827,3137.449,1911.395,3139.009,1908.746,3139.009z  M1886.32,3126.996l20.36,1.763l8.664-19.544l2.75-0.398c9.325-1.351,18.29-4.186,26.65-8.427l2.475-1.256l18.349,10.985 l15.622-13.15l-7.695-19.952l1.66-2.225c5.599-7.511,9.921-15.862,12.845-24.824l0.861-2.642l20.736-5.204l1.735-20.363 l-19.554-8.692l-0.4-2.742c-1.359-9.322-4.207-18.295-8.461-26.671l-1.254-2.475l10.959-18.339l-13.176-15.651l-19.941,7.672 l-2.223-1.66c-7.521-5.617-15.88-9.95-24.839-12.883l-2.633-0.863l-5.232-20.749l-20.36-1.763l-8.664,19.544l-2.75,0.398 c-9.325,1.351-18.29,4.186-26.649,8.426l-2.475,1.256l-18.349-10.985l-15.622,13.15l7.695,19.952l-1.66,2.225 c-5.599,7.511-9.921,15.862-12.845,24.824l-0.861,2.642l-20.736,5.204l-1.735,20.363l19.554,8.692l0.399,2.742 c1.359,9.322,4.208,18.295,8.461,26.671l1.254,2.475l-10.959,18.341l13.176,15.649l19.941-7.672l2.223,1.66 c7.521,5.617,15.88,9.95,24.839,12.883l2.633,0.863L1886.32,3126.996z M1981.648,2946.343l-0.01,0.003 C1981.638,2946.346,1981.645,2946.344,1981.648,2946.343z M1979.841,2941.649h0.033H1979.841z M1905.046,3088.547 c-18.749,0-37.379-7.958-50.378-23.4c-23.352-27.739-19.81-69.283,7.898-92.607c27.701-23.323,69.242-19.731,92.597,8.01 c3.016,3.582,5.651,7.483,7.835,11.594c1.3,2.453,0.367,5.498-2.086,6.799c-2.443,1.305-5.497,0.373-6.801-2.084 c-1.85-3.484-4.083-6.791-6.643-9.833c-19.777-23.49-54.953-26.545-78.426-6.792c-23.464,19.754-26.46,54.939-6.679,78.436 c19.78,23.493,54.959,26.548,78.426,6.792c7.714-6.498,13.513-14.944,16.764-24.428c0.904-2.626,3.756-4.031,6.388-3.125 c2.629,0.902,4.027,3.762,3.127,6.39c-3.844,11.206-10.691,21.187-19.803,28.858 C1934.983,3083.498,1919.976,3088.547,1905.046,3088.547z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgService5);
export default __webpack_public_path__ + "static/media/service5.7c0a9bb74e8c45d0c61efa2715e228f7.svg";
export { ForwardRef as ReactComponent };